// @ai-generated 2026-08-27T08:12:58+00:00 by malte.ulfers@tngtech.com using Claude Opus 5 (1M context)
import { concatUrlSegments } from '@utils/concatUrlSegments';
import type { ValidationFailure, ValidationOutcome } from '@utils/toolCallEnvelope';
import entityClasses from './ChatEntityToolCallCard.module.css';
import classes from './RejectedRecordTable.module.css';
import type { ValidationTool } from './validationTools';

/** Shared by the chat transcript and the run monitor, so the two cannot disagree about a rejection. */
export function RejectedRecordTable({
    outcome,
    tool,
    subpath,
}: {
    outcome: ValidationOutcome;
    tool: ValidationTool;
    subpath: string;
}) {
    // Hard failures first: they are what stopped the batch, while a soft failure only filtered a
    // record out and the run carried on.
    const rows = [
        ...outcome.hardFailed.map((failure) => ({ failure, soft: false })),
        ...outcome.softFailed.map((failure) => ({ failure, soft: true })),
    ];

    return (
        <table className={entityClasses.table}>
            <thead>
                <tr>
                    <th className={entityClasses.headerCell}>{tool.entityLabel}</th>
                    <th className={entityClasses.headerCell}>Grund</th>
                </tr>
            </thead>
            <tbody>
                {rows.map(({ failure, soft }, index) => (
                    <tr key={failure.entityId ?? `${failure.message}:${index}`}>
                        <td className={entityClasses.cell}>
                            <RecordIdentifier failure={failure} tool={tool} subpath={subpath} />
                        </td>
                        <td className={classes.reasonCell}>
                            {failure.message}
                            {soft && <span className={classes.severity}> (übersprungen)</span>}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

/**
 * Opens in a new tab like the search cards: the chat mints a fresh thread on mount, so navigating
 * this tab away would discard the conversation. A record with no label falls back to the ruleset.
 */
function RecordIdentifier({
    failure,
    tool,
    subpath,
}: {
    failure: ValidationFailure;
    tool: ValidationTool;
    subpath: string;
}) {
    const label = failure.entityLabel ?? failure.rulesetTitle;
    const shown = label === '' ? '—' : label;

    if (failure.entityId === undefined || failure.entityId === '') {
        return <>{shown}</>;
    }

    return (
        <a
            href={concatUrlSegments('/', subpath, tool.detailPath(failure.entityId))}
            target="_blank"
            rel="noreferrer"
            className={entityClasses.link}
        >
            {shown}
        </a>
    );
}
